/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-06 17:18:58
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-27 14:01:11
 * @FilePath: /dsicm-admin-web/src/views/OrderManagement/common/interrogation.js
 */
export default {
    data() {
      return {  
        /**全病程问诊 */
        // 机构
        tabListL1Config: [
          {
            label: '序号',
            align: 'center',
            fixed: 'left',
            prop: 'date',
            size: 'mini',
            width: '50px',
            render: (h, scope) => {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            },
          },
          {
            label: '订单编号',
            align: 'center',
            prop: 'orderNo',
            size: 'mini',
            showOverflowTooltip: true
          },
          {
            label: '抵扣权益',
            align: 'center',
            size: 'mini',
            showOverflowTooltip:true,
            render: (h, scope) => {
              return <span slot="reference">
                {
                  scope.row.paymentMethid == 4 ? scope.row.serviceName:
                 '--'
                }
                </span>
            },
          },
          {
            label: '问诊类型',
            align: 'center',
            size: 'mini',
            showOverflowTooltip:true,
            render: (h, scope) => {
              return <span>{
                  scope.row.returnVisitType == 1 ? '图文问诊' : 
                  '--'
                }
              </span>
            },
          },
          {
            label: '服务类型',
            align: 'center',
            size: 'mini',
            showOverflowTooltip:true,
            render: (h, scope) => {
              return <span>{
                scope.row.inquiryType == 3 ? '义诊' : scope.row.inquiryType  == 2?"付费问诊":'权益问诊'
                }
              </span>
            },
          },
          {
            label: '病人',
            align: 'center',
            prop: 'patientName',
            width:'120px',
            render: (h, scope) => {
              return <span slot="reference">{!scope.row.logOff ? scope.row.patientName :scope.row.patientName + '(已注销)'} </span>
            },
          },
          // {
          //   label: '病种',
          //   align: 'center',
          //   size: 'mini',
          //   prop:'diseaseType',
          //   showOverflowTooltip:true,
          //   render: (h, scope) => {
          //     return <span>-</span>
          //   },
          // },
          // {
          //   label: '服务方案',
          //   align: 'center',
          //   size: 'mini',
          //   width:'300px',
          //   prop:'patientSchemeName',
            
          //   showOverflowTooltip:true,
          //   render: (h, scope) => {
          //     return <span>-</span>
          //   },
          // },
          {
            label: '医生/医生团队',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="doctorName">
                {
                  scope.row.serviceProvider == 1 ? scope.row.doctorName : 
                  scope.row.doctorTeamName 
                }
                </span>
            },
          },
          // {
          //   label: '线下机构',
          //   align: 'center',
          //   size: 'mini',
          //   prop: 'hospitalName',

          // },
          // {
          //   label: '互医机构',
          //   align: 'center',
          //   size: 'mini',
          //   prop: 'platformName',
          // },
          // {
          //   label: '归属平台',
          //   align: 'center',
          //   prop: 'platformName',
          //   size: 'mini',
          // showOverflowTooltip:true

          // },
          {
            label: '创建时间',
            align: 'center',
            prop: 'createTime',
            size: 'mini',
            showOverflowTooltip: true
          },
          {
            label: '问诊结束时间',
            align: 'center',
            prop: 'inquiryEndTime',
            size: 'mini'
          },
          {
            label: '服务单价',
            align: 'center',
            prop: 'amountOriginal',
            size: 'mini'
          },
          {
            label: '问诊状态',
            align: 'center',
            size: 'mini',
            prop:'inquiryStatusName'
          },
          {
            label: '订单状态',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="reference">
                {
                  scope.row.paymentState == 1 ? '待支付' : 
                  scope.row.paymentState == 2 ? '已支付' : 
                  scope.row.paymentState == 3 ? '已取消' : 
                  scope.row.paymentState == 4 ? '已退款' : 
                  scope.row.paymentState == 7 ? '已完成' :
                  scope.row.paymentState == 8 ? '待退款' :
                 '未知'
                }
                </span>
            },
          },
          {
            label: '操作',
            align: 'center',
            width: '100px',
            fixed: 'right',
            render: (h, scope) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: { type: 'text', size: 'mini' },
                    on: {
                      click: () => {
                        this.hometHandel(scope, 'details')
                      },
                    },
                  },
                  '详情'
                ),
                // h(
                //   'el-button',
                //   {
                //     props: { type: 'text', size: 'mini' },
                //     attrs: { disabled: scope.row.paymentState == 4 ? true : false},
                //     on: {
                //       click: () => {
                //         this.hometHandel(scope, 'refund')
                //       },
                //     },
                //   },
                //   '记录'
                // ),
                h(
                  'el-button',
                  {
                    props: { type: 'text', size: 'mini' },
                    attrs: {
                      disabled: scope.row.paymentState != 8  ? true : false,
                    },
                    on: {
                      click: () => {
                        this.hometRefundHandel(scope.row)
                      },
                    },
                  },
                   '退款'
                ),
              ])
            },
          },
        ],
        // 平台
        tabListL2Config: [
          {
            label: '序号',
            align: 'center',
            fixed: 'left',
            prop: 'date',
            size: 'mini',
            width: '50px',
            render: (h, scope) => {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            },
          },
          {
            label: '订单编号',
            align: 'center',
            prop: 'orderNo',
            size: 'mini',
            showOverflowTooltip:true 
          },
          {
            label: '抵扣权益',
            align: 'center',
            size: 'mini',
            showOverflowTooltip:true,
            render: (h, scope) => {
              return <span slot="reference">
                {
                  scope.row.paymentMethid == 4 ? scope.row.serviceName:
                 '--'
                }
                </span>
            },
          },
          {
            label: '问诊类型',
            align: 'center',
            size: 'mini',
            prop: 'returnVisitType',
          showOverflowTooltip:true,
            render: (h, scope) => {
              return <span>{
                  scope.row.returnVisitType == 1 ? '图文问诊' : 
            //       scope.row.commodityType == 2 ? '药品订单' : 
            //       scope.row.commodityType == 3 ? '问诊订单' : 
                  '未知订单'
                }
              </span>
            },
          },
          {
            label: '服务类型',
            align: 'center',
            size: 'mini',
            prop: 'inquiryType',
            showOverflowTooltip:true,
            render: (h, scope) => {
              return <span>{
                  scope.row.inquiryType == 3 ? '义诊' : scope.row.inquiryType  == 2?"付费问诊":'权益问诊'
                }
              </span>
            },
          },
          {
            label: '病人',
            align: 'center',
            prop: 'patientName',
            width:'120px',
            render: (h, scope) => {
              return <span slot="reference">{!scope.row.logOff ? scope.row.patientName :scope.row.patientName + '(已注销)'} </span>
            },
          },
          // {
          //   label: '病种',
          //   align: 'center',
          //   size: 'mini',
          //   prop:'diseaseType',
          //   showOverflowTooltip:true,
          //   render: (h, scope) => {
          //     return <span>-</span>
          //   },
          // },
          // {
          //   label: '服务方案',
          //   align: 'center',
          //   size: 'mini',
          //   width:'300px',
          //   prop:'patientSchemeName',
            
          //   showOverflowTooltip:true,
          //   render: (h, scope) => {
          //     return <span>-</span>
          //   },
          // },
          {
            label: '医生/医生团队',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="doctorName">
                {
                  scope.row.serviceProvider == 1 ? scope.row.doctorName : 
                  scope.row.doctorTeamName 
                }
                </span>
            },

          },
          {
            label: '线下机构',
            align: 'center',
            size: 'mini',
            prop: 'hospitalName',

          },
          {
            label: '互医机构',
            align: 'center',
            size: 'mini',
            prop: 'platformName',

          },
          // {
          //   label: '归属平台',
          //   align: 'center',
          //   prop: 'platformName',
          //   size: 'mini',
          // showOverflowTooltip:true

          // },
          {
            label: '创建时间',
            align: 'center',
            prop: 'createTime',
            size: 'mini',
            showOverflowTooltip:true
          },
        
          {
            label: '问诊结束时间',
            width:'120px',
            align: 'center',
            prop: 'inquiryEndTime',
            size: 'mini'
          },
          {
            label: '服务单价',
            align: 'center',
            prop: 'amountOriginal',
            size: 'mini',
          showOverflowTooltip:true

          },
          {
            label: '问诊状态',
            align: 'center',
            size: 'mini',
            prop: 'inquiryStatusName',
          showOverflowTooltip:true,
          },
          {
            label: '订单状态',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="reference">
                {
                  scope.row.paymentState == 1 ? '待支付' : 
                  scope.row.paymentState == 2 ? '已支付' : 
                  scope.row.paymentState == 3 ? '已取消' : 
                  scope.row.paymentState == 4 ? '已退款' : 
                  scope.row.paymentState == 7 ? '已完成' :
                  scope.row.paymentState == 8 ? '待退款' :
                 '未知'
                }
                </span>
            },
          },
          {
            label: '操作',
            align: 'center',
            width: '100px',
            fixed: 'right',
            render: (h, scope) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: { type: 'text', size: 'mini' },
                    on: {
                      click: () => {
                        this.hometHandel(scope, 'details')
                      },
                    },
                  },
                  '详情'
                ),
                // h(
                //   'el-button',
                //   {
                //     props: { type: 'text', size: 'mini' },
                //     attrs: { disabled: scope.row.paymentState == 4 ? true : false},
                //     on: {
                //       click: () => {
                //         this.hometHandel(scope, 'refund')
                //       },
                //     },
                //   },
                //   '记录'
                // ),
                h(
                  'el-button',
                  {
                    props: { type: 'text', size: 'mini' },
                    attrs: {
                      disabled: scope.row.paymentState != 8  ? true : false,
                    },
                    on: {
                      click: () => {
                        this.hometRefundHandel(scope.row)
                      },
                    },
                  },
                   '退款'
                ),
              ])
            },
          },
        ],
       
        /**服务管理 */
        serviceConfig: [
          {
            label: '序号',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            },
          },
          { label: '服务开始时间', align: 'center', prop: 'name1', size: 'mini' },
          { label: '服务结束时间', align: 'center', prop: 'name2', size: 'mini' },
          {
            label: '操作',
            align: 'center',
            size: 'mini',
            render: (h, scope) => {
              return (
                <div>
                  <el-button size="mini" type="text" onClick={() => this.hometHandel(scope, 'details')}>
                    查看记录
                  </el-button>
                </div>
              )
            },
          },
        ],
        /**处方内容 */
        prescriptionConfigL: [
          {
            label: '序号',
            align: 'center',
            fixed: 'left',
            size: 'mini',
            width: '50px',
            render: (h, scope) => {
              return <span slot="reference">{scope.$index * 1 + 1}</span>
            },
          },
          {
            label: '药品品名',
            align: 'center',
            prop: 'drugName',
            size: 'mini',
          },
          {
            label: '规格包装',
            align: 'center',
            prop: 'drugSpecification',
            size: 'mini',
          },
          {
            label: '生产商',
            align: 'center',
            prop: 'orderNo12',
            size: 'mini',
          },
          {
            label: '数量',
            align: 'center',
            prop: 'medicationNumber',
            size: 'mini',
          },
          {
            label: '单价',
            align: 'center',
            prop: 'drugPrice',
            size: 'mini',
            render: (h, scope) => {
              return <span slot="reference">{scope.row.drugPrice}/￥</span>
            },
          },
        ],
      }
    },
  }
  